import './rumi/style';
import FormStructure from './rumi/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// c:/_Development/Web Inquiry/inquiry-renderer/client_forms/includes.js